
import { success } from "services/common";
import { COMMON_TYPES } from "../../../types";

export const setSelectedFileName = (data) => {
    return async (dispatch) => {
        dispatch(success(COMMON_TYPES.ATTACHMENT_FILE_LISTING, data));
    };
  }